import $ from 'jquery';
import anime from 'animejs';
const initModuleCards = () => {
    const moduleCardsContainers = document.querySelectorAll('[data-module-cards]');
    if (!moduleCardsContainers.length) return;

    setTimeout(() => {
        initModuleCardsHover();
    }, 100);
};

const initModuleCardsHover = () => {
    const isMobile = window.innerWidth <= 767;
    if (isMobile) return;

    document.querySelectorAll('.module_cards_card:has(.module_cards_card_link)').forEach((card) => {
        if (card.dataset.hoverInit === '1') return;
        card.dataset.hoverInit = '1';

        let domBubble = document.createElement('div');
        domBubble.classList.add('module_cards_card_circle_bubble');

        let domCircle = document.createElement('div');
        domCircle.appendChild(domBubble);
        domCircle.classList.add('module_cards_card_circle');

        card.appendChild(domCircle);

        let circle = card.querySelector('.module_cards_card_circle');
        let bubble = card.querySelector('.module_cards_card_circle_bubble');

        if (!circle || !bubble) return;

        const calculateBubbleSize = (posX, posY) => {
            const cardBounds = card.getBoundingClientRect();
            const cardWidth = cardBounds.width;
            const cardHeight = cardBounds.height;

            const corners = [
                { x: 0, y: 0 },
                { x: cardWidth, y: 0 },
                { x: 0, y: cardHeight },
                { x: cardWidth, y: cardHeight }
            ];

            let maxDistance = 0;
            corners.forEach(corner => {
                const distance = Math.sqrt(
                    Math.pow(corner.x - posX, 2) +
                    Math.pow(corner.y - posY, 2)
                );
                if (distance > maxDistance) {
                    maxDistance = distance;
                }
            });

            return Math.ceil(maxDistance * 2.2);
        };

        let cardBounds = card.getBoundingClientRect();

        card.addEventListener('mouseenter', (e) => {
            cardBounds = card.getBoundingClientRect();
            let posX = e.clientX - cardBounds.left;
            let posY = e.clientY - cardBounds.top;

            const bubbleSize = calculateBubbleSize(posX, posY);

            bubble.style.width = bubbleSize + 'px';
            bubble.style.height = bubbleSize + 'px';
            bubble.style.marginLeft = (-bubbleSize / 2) + 'px';
            bubble.style.marginTop = (-bubbleSize / 2) + 'px';

            circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';

            bubble.style.transform = 'scale(1)';
            bubble.style.opacity = '1';
        });

        card.addEventListener('mouseleave', () => {
            bubble.style.transform = 'scale(0)';
            bubble.style.opacity = '0';
        });
    });
};

export { initModuleCards, initModuleCardsHover };
